export const USER_STATUS_OPTIONS = [
  { value: 'ACTIVE', title: 'Active' },
  { value: 'INACTIVE', title: 'Inactive' },
]

export function formatUserStatus(status) {
  const key = String(status ?? '').toUpperCase()
  if (key === 'ACTIVE') return 'Active'
  if (key === 'INACTIVE') return 'Inactive'
  return key ? key.replace(/_/g, ' ') : '—'
}
